import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import bash from 'react-syntax-highlighter/dist/esm/languages/hljs/bash';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import "../CSS/Home.css";
import profileimg from "../pages/assets/rpx.jpg";

// Register the bash language for syntax highlighting
SyntaxHighlighter.registerLanguage('bash', bash);

const Home = () => {
  const { t } = useTranslation();

  const bashCode = `
  npm install life
  npm install coffee
  npm install code

  const life = require('life');
  const coffee = require('coffee');
  const code = require('code');

  #enjoy life is commented out
  
  # Start the day
  life.start();
  coffee.brew();
  code.write();
  `;

  return (
    <div className="home">
      <div className="about">
        <img
          src={profileimg}
          alt={t('RAMSWAROOP PATEL')}
          className="profile-img" 
        />
        <h1>{t('intro')}</h1>
        <p>{t('about')}</p>
        <div className="developer-code">
          <SyntaxHighlighter language="bash" class="devcodebash" style={github}>
            {bashCode}
          </SyntaxHighlighter>
        </div>
      </div>
      {/* <div className="navigation-circles">
        <Link to="/resume" className="circle circle1">{t('resume')}</Link>
        <Link to="/projects" className="circle circle2">{t('projects')}</Link>
        <Link to="/contact" className="circle circle3">{t('contact')}</Link>
        <Link to="/about-rpx" className="circle circle3">{t('About')}</Link>
        <Link to="/achievements" className="circle circle3">{t('Achievements')}</Link>
      </div> */}
    </div>
  );
};

export default Home;